import React from "react";

import { View } from "react-native";
import { IconButton, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useCropperContext from "../context/cropper";
import useEditorContext from "../context/editor";

export default function AspectRatioIcons() {
  const { setAspectRatio } = useEditorContext();
  const { editingMode } = useCropperContext();
  const tailwind = useTailwind();

  if (!setAspectRatio || editingMode !== "crop") return null;

  return (
    <View style={tailwind("flex-row items-center justify-center")}>
      <Icon icon="crop-square" aspectRatio={1} />
      <Icon icon="crop-portrait" aspectRatio={2 / 3} />
      <Icon icon="crop-landscape" aspectRatio={3 / 2} />
    </View>
  );
}

function Icon({ aspectRatio, icon }: { aspectRatio: number; icon: string }) {
  const { colors } = useTheme();
  const { setAspectRatio } = useEditorContext();

  return (
    <IconButton
      icon={icon}
      iconColor={colors.onSurface}
      onPress={() => setAspectRatio?.(aspectRatio)}
    />
  );
}
